export default __webpack_public_path__ + "static/media/bg-settings-top.21d727d6.png";